// @flow
import RequestProductModalContainer from './RequestProductModalContainer'
export default RequestProductModalContainer
